
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 4h2v12h-2V4zm-3 .688v2.156C8.474 8.39 6 11.909 6 16c0 5.514 4.486 10 10 10s10-4.486 10-10c0-4.091-2.474-7.609-6-9.156V4.688c4.654 1.651 8 6.099 8 11.313 0 6.617-5.383 12-12 12s-12-5.383-12-12c0-5.213 3.346-9.662 8-11.313z"}})])
          )
        }
      }
    